const DAY_MINUTES = 24 * 60;
const HALF_DAY_MINUTES = DAY_MINUTES / 2;

/**
 * Minutes past the end of the grace window that someone arrived (0 when on time or early).
 *
 * Both times are wall-clock minutes since midnight in the employee's zone. The gap is folded into
 * (-12h, +12h] so a shift that crosses midnight reads correctly: for a 22:00 shift, arriving at
 * 00:30 is 2h30 late (not "early by 21h30"), and arriving at 21:50 is 10 minutes early. Anyone more
 * than half a day from the start is ambiguous by nature and is read as the nearer occurrence.
 */
export function minutesLate(arrived: number, shiftStart: number, graceMinutes: number): number {
  const gap =
    ((((arrived - shiftStart + HALF_DAY_MINUTES) % DAY_MINUTES) + DAY_MINUTES) % DAY_MINUTES) -
    HALF_DAY_MINUTES;
  // The fold puts exactly +12h at -12h; that boundary is far outside any real shift's grace.
  return Math.max(0, gap - graceMinutes);
}
